import Avatar1 from '../../assets/avatar1.jpg'
import Avatar2 from '../../assets/avatar2.jpg'
import Avatar3 from '../../assets/avatar3.jpg'
import Avatar4 from '../../assets/avatar4.jpg'
import Avatar5 from '../../assets/avatar5.jpg'
import Avatar6 from '../../assets/avatar6.jpg'
import Avatar7 from '../../assets/avatar7.jpg'


const data = [
        {
        id: 1,
        quote: "Exceptional problem solver, consistently delivering elegant solutions. You'll be my go-to developer from today. Highly recommend!",
        avatar: Avatar1,
        name: 'Jill Smith',
        profession: 'UX Designer'

        },
        {
        id: 2,
        quote: "Reliable and innovative developer who consistently meets project goals.It was fun collaborating with you Alex.",
        avatar: Avatar2,
        name: 'Samuel Rodriguez',
        profession: 'Front-end Developer'

        },
        {
        id: 3,
        quote: "A collaborative team player, adept at communicating technical concepts to non-technical stakeholders.",
        avatar: Avatar3,
        name: 'Benjamin Thompson',
        profession: 'Back-end Developer'
        },
        {
        id: 4,
        quote: "Wow. Exceptional problem solver, consistently delivering elegant solutions to complex coding challenges",
        avatar: Avatar4,
        name: 'Sophia Patel',
        profession: 'DevOps Engineer'
        },
        {
        id: 5,
        quote: "Innovative thinker who brings fresh perspectives to complex coding challenges. You are incredible, Alex.",
        avatar: Avatar5,
        name: 'Isabella Mitchell',
        profession: 'Full Stack Developer'
        },
        {
        id: 6,
        quote: "A true team player, adept at collaborating across departments to achieve project goals",
        avatar: Avatar6,
        name: 'Emma Williams',
        profession: 'UX Designer'
        },
        {
        id: 7,
        quote: "Keep doing great stuff, dear! Nicely executed!",
        avatar: Avatar7,
        name: 'Chloe Davis',
        profession: 'Frontend Developer'
        }
    ]



    export default data